import React from 'react'
import cn from 'classnames'

import { paths } from '@mc/paths'

import Link from 'components/Link/CustomLink'
import { trackSubcategoryClicked } from '../../events'

interface SubcatSelectionTabsProps {
  categorySlug: string
  subcatSlug: string
  subcatName: string
  index: number
  children: React.ReactNode
}

export const SubcatSelectionTabs = ({
  categorySlug,
  subcatSlug,
  subcatName,
  index,
  children,
}: SubcatSelectionTabsProps) => (
  <Link
    ariaHidden
    className={cn(
      'mc-h-100 mc-p-3 mc-mr-lg-4 mc-bg-gray-100 mc-corners--sm d-flex align-items-center justify-content-between',
      { 'mc-mr-md-4': index % 2 === 0 },
    )}
    href={paths.subcategoryPage(subcatSlug)}
    tabIndex={-1}
    onClick={() =>
      trackSubcategoryClicked({
        categorySlug,
        subcategoryName: subcatName,
      })
    }
    passHref
  >
    {children}
  </Link>
)
